import React from "react";
import { Card, Avatar, Button, Spin, Empty } from "antd";
import { useTranslation } from "react-i18next";
import {
  scoreColor,
  initials,
  formatTime,
  formatShortDate,
} from "./evalDashboardUtils";
import styles from "./TeacherEvalDashboard.module.scss";

// T4 — Detalle de alumno: ficha + examenes realizados (mejor marca %) + ranking.
export function StudentDetail({ data, loading, onOpenRanking }) {
  const { t } = useTranslation("evaluations");
  if (loading) {
    return (
      <div className={styles.center}>
        <Spin />
      </div>
    );
  }
  if (!data) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t("dashboard.cantLoadStudent")}
      />
    );
  }

  const { student, exams = [] } = data;
  const doneCount = exams.filter((e) => e.done).length;
  const doneScores = exams.filter((e) => e.done).map((e) => e.bestScore);
  const avg = doneScores.length
    ? Math.round(doneScores.reduce((s, v) => s + v, 0) / doneScores.length)
    : 0;

  return (
    <div className={styles.detailGrid}>
      <Card className={styles.profileCard} variant="outlined">
        <Avatar size={92} src={student.avatar || undefined}>
          {initials(student.name, student.surname)}
        </Avatar>
        <div className={styles.profileName}>
          {student.name} {student.surname}
        </div>
        <div className={styles.profileMeta}>{student.classnumber}</div>
        <div className={styles.profileChips}>
          <span className={styles.profileChip}>
            {t("dashboard.examsChip", { count: doneCount })}
          </span>
          <span className={styles.profileChip}>
            {t("dashboard.averageChip", { value: avg })}
          </span>
        </div>
      </Card>

      <Card className={styles.examCard} variant="outlined">
        <h3 className={styles.sectionTitle}>
          {t("dashboard.examsRealizados")}
        </h3>
        {exams.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t("dashboard.noExams")}
          />
        ) : (
          exams.map((e) => (
            <div className={styles.examRow} key={e.teacherQuizId}>
              <div className={styles.examInfo}>
                <div className={styles.examName}>
                  <span>{e.name}</span>
                  {e.done ? (
                    <span
                      className={styles.scorePill}
                      style={{ background: scoreColor(e.bestScore) }}
                    >
                      {e.bestScore} %
                    </span>
                  ) : (
                    <span className={styles.doneBadge}>
                      {t("dashboard.notDone")}
                    </span>
                  )}
                </div>
                {e.done && (
                  <div className={styles.examMeta}>
                    {t("dashboard.attempts", { count: e.attempts })} ·{" "}
                    {t("dashboard.best")} {e.bestCorrect}/{e.total} ·{" "}
                    {formatTime(e.bestTime)} · {formatShortDate(e.lastAt)}
                  </div>
                )}
              </div>
              {e.done && (
                <Button
                  type="link"
                  className={styles.linkGreen}
                  onClick={() => onOpenRanking(e)}
                >
                  {t("dashboard.viewRanking")}
                </Button>
              )}
            </div>
          ))
        )}
      </Card>
    </div>
  );
}
